export default [{
  name: 'User',
  value: 'user'
}, {
  name: 'Institution',
  value: 'institution'
}]
